import { dataSlideshowTrend } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSlideshowTrend = /*#__PURE__*/createIcon(dataSlideshowTrend)
export default IconSlideshowTrend
